/* eslint-disable */
import React, { useMemo } from 'react'

import useConfiguration from '../../hooks/useConfiguration'
import { useIntl } from '../../intl/intl'
import router from '../../router'
import routes from '../../router/routes'
import LayoutGame from '../../components/LayoutGame'
import GamePageTemplate from '../../templates/GamePage'
import * as appConfiguration from '../../configuration'


export default function withGameClosed(WrappedComponent) {
  return (props) => {
    const { pageContext, location } = props
    const { configuration, isGameClosed, seoFallback } = useConfiguration()
    const t = useIntl()

    if (isGameClosed) {
      const homepageProps = useMemo(() => ({
        layoutProps: {
          seo: {
            lang: pageContext?.language ?? null,
            title: seoFallback?.title ?? '',
            description: seoFallback?.description?.description ?? '',
            image: appConfiguration.app.url + seoFallback?.picture?.localFile?.childImageSharp?.fluid?.src ?? '',
            url: location?.href ?? '',
          },
          videoBackgroundSources: [
            {
              src: t('background_video_path'),
              type: 'video/mp4',
            },
          ],
        },
        startNavProps: {
          buttons: [
            {
              text: t('watch_video'),
              variant: 'bigwhite',
              gatsbyLink: {
                route: router(routes.video.path),
              },
            },
            {
              text: t('home_lookbook'),
              variant: 'bigtransparent',
              gatsbyLink: {
                route: router(routes.looks.path),
              },
            },
          ],
        },
      }), [configuration, t, seoFallback, location])

      return (
        <LayoutGame {...homepageProps.layoutProps}>
          <GamePageTemplate startNavProps={homepageProps.startNavProps} />
        </LayoutGame>
      )
    }

    return <WrappedComponent {...props} />
  }
}
